import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { GoogleReview } from '../../../core/models/google/google.dto';
import { GoogleService } from '../../../core/services/google/google.service';

@Component({
  selector: 'app-google-reviews',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google-reviews.component.html',
  styleUrl: './google-reviews.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleReviewsComponent implements OnInit {
  reviews: GoogleReview[] = [];

  constructor(private googleService: GoogleService) { }

  ngOnInit(): void {
    this.googleService.getGoogleReviews().subscribe({
      next: (response: GoogleReview[]) => {
        this.reviews = response ?? [];
        return;
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
        return;
      }
    });
  }
}
